import * as Yup from "yup";

const ProductVersionSchema = () => Yup.object().shape({
  version_ids: Yup
    .array()
    .label("Versions")
});

export default ProductVersionSchema;
